import SessionManager from '../services/SessionManager';

/*
 * AuthService is a Singleton because it is instantiated here as a constant and the one instantiation is exported.
 * Any number of imports will use this one service (and therefore, its state)
 */

class AuthService {
    constructor() {
        // Get authentication from session state
        this._userId = SessionManager.getItem(this.authSessionUserId);
        this._userName = SessionManager.getItem(this.authSessionUserName);
        this._userFirstName = SessionManager.getItem(this.authSessionUserFirstName);
        this._userLastName = SessionManager.getItem(this.authSessionUserLastName);
        this._userDegrees = SessionManager.getItem(this.authsessionUserDegrees);
        this._token = SessionManager.getItem(this.authSessionToken);
        this._accessToken = SessionManager.getItem(this.authSessionAccessToken);
        this._isCaregiver = SessionManager.getItem(this.authSessionCaregiver);
        this._isPartner = SessionManager.getItem(this.authSessionPartner);
        this._partnerRole = SessionManager.getItem(this.authSessionPartnerRole)
        this._isRater1 = SessionManager.getItem(this.authSessionRater1);
        this._isRater2 = SessionManager.getItem(this.authSessionRater2);
        this._isRater3 = SessionManager.getItem(this.authSessionRater3);
        this._restrictedDomains = SessionManager.getItem(this.authSessionRestrictedDomains);
    }

    authSessionToken = "ccpaiapit";
    authSessionAccessToken = "ccpaiapiat"
    authSessionUserId = "ccpcaiauid";
    authSessionUserName = "ccpcaiuna";   // Not sure if we need to retain username in state.  Better if we didn't.
    authSessionUserFirstName = "ccpcaiufn";
    authSessionUserLastName = "ccpcaiuln";
    authSessionUserDegrees = "ccpcaiude";
    authSessionCaregiver = "ccpaicar";
    authSessionRater1 = "ccpaira1";
    authSessionRater2 = "ccpaira2";
    authSessionRater3 = "ccpaira3"
    authSessionPartner = "ccpaipar";
    authSessionPartnerRole = "ccpaippr";
    authSessionRestrictedDomains = "ccpaiurd";

    get isAuthenticated() {
        return this._userId > 0;
    }

    get isParentAccount() {
        return String(this._isPartner) == "true";
    }

    get isCaregiver() {
        return String(this._isCaregiver) == "true";
    }

    get isRater1() {
        return String(this._isRater1) == "true";
    }

    get isRater2() {
        return String(this._isRater2) == "true";
    }

    get isRater3() {
        return String(this._isRater3) == "true";
    }

    get isRaterOrCaregiver() {
        return String(this._isRater1) == "true" || String(this._isRater2) == "true" || String(this._isRater3) == "true"|| String(this._isCaregiver) == "true";
    }

    get isCaregiverOrRater() {
        return String(this._isRater1) == "true" || String(this._isRater2) == "true" || String(this._isRater3) == "true" || String(this._isCaregiver) == "true";
    }

    get isPartnerProvider() {
        return String(this._isPartner) == "true";
    }

    get partnerRole() {
        return parseInt(this._partnerRole, 10);
    }

    get isClearClinician() {
        return !this.isCaregiverOrRater && !this.isPartnerProvider;
    }

    get authenticatedUserId() {
        return this._userId;
    }

    get authenticatedUserName() {
        // Not sure why but null cookie values are empty strings - make them null.
        return this._userName;
    }

    get authenticatedUserFirstName() {
        return this._userFirstName;
    }

    get authenticatedUserLastName() {
        return this._userLastName;
    }

    get authenticatedUserDegrees() {
        return (this._userDegrees == "") ? null : this._userDegrees;
    }

    get authenticatedUserRestrictedDomains() {
        return (this._restrictedDomains == "") ? null : this._restrictedDomains;
    }

    get authenticatedUserToken() {
        return this._token;
    }

    get authenticatedUserAccessToken() {
        return this._accessToken;
    }

    get userType() {
        let userType = 0;
        if (this.isPartnerProvider) {
            userType = 2;
        }
        else if (this.isCaregiver) {
            userType = 3;
        }
        else if (this.isRater1) {
            userType = 4;
        }
        else if (this.isRater2) {
            userType = 5;
        }
        else if (this.isRater3) {
            userType = 6;
        }
        else {
            userType = 1;
        }
        return userType;
    }

    get userTypeAsString() {
        return this.getUserTypeAsString (this.userType, false)
    }

    getUserTypeAsString(userType, formatReturn) {
        var utas = null;
        var retVal = null;
        switch (userType) {
            case 1:
                utas = "Clinician";
                break;

            case 2:
                utas = "Parent";
                break;

            case 3:
            case 6:
                utas = "Rater 3";
                break;

            case 4:
                utas = "Rater 1";
                break;

            case 5:
                utas = "Rater 2";
                break;

            default:
                // Can't happen (that covers all types)
                break;
        }
        if (formatReturn && this.userType == userType) {
            utas += " (Your)"
        }
        return (formatReturn) ? " " + utas + " Responses" : utas;
    }

    get token() {
        return this._token;
    }

    setAuthenticated(token, accessToken, id, userName, userFN, userLN, userDeg, isGuest, isRater1, isRater2, isRater3, isPartner, partnerRole, restrictedDomains) {
        // Set locals for use in app
        this._token = token;
        this._accessToken = accessToken;
        this._userId = id;
        this._userName = userName;
        this._userFirstName = userFN;
        this._userLastName = userLN;
        this._userDegrees = (userDeg == null) ? "" : userDeg;
        this._isCaregiver = isGuest;
        this._isRater1 = isRater1;
        this._isRater2 = isRater2;
        this._isRater3 = isRater3;
        this._isPartner = isPartner;
        this._partnerRole = partnerRole;
        this._restrictedDomains = (restrictedDomains == null) ? "" : restrictedDomains;

        // Retain in state. 
        SessionManager.setItem(this.authSessionToken, this.token);
        SessionManager.setItem(this.authSessionAccessToken, this.accessToken);
        SessionManager.setItem(this.authSessionUserId, this._userId);
        SessionManager.setItem(this.authSessionUserName, this._userName);
        SessionManager.setItem(this.authSessionUserFirstName, this._userFirstName);
        SessionManager.setItem(this.authSessionUserLastName, this._userLastName);
        SessionManager.setItem(this.authSessionUserDegrees, this._userDegrees);
        SessionManager.setItem(this.authSessionCaregiver, this._isCaregiver);
        SessionManager.setItem(this.authSessionRater1, this._isRater1);
        SessionManager.setItem(this.authSessionRater2, this._isRater2);
        SessionManager.setItem(this.authSessionRater3, this._isRater3);
        SessionManager.setItem(this.authSessionPartner, this._isPartner);
        SessionManager.setItem(this.authSessionPartnerRole, this._partnerRole);
        SessionManager.setItem(this.authSessionRestrictedDomains, this._restrictedDomains);
    }

    clearAuthenticated() {
        this._userId = 0;
        this._userName = null;
        this._userFirstName = null;
        this._userLastName = null;
        this._userDegrees = null;
        this._isCaregiver = false;
        this._isRater1 = false;
        this._isRater2 = false;
        this._isRater3 = false;
        this._isPartner = false;
        this._partnerRole = -1;
        this._token = null;
        this._restrictedDomains = null;
        SessionManager.removeAllItems();
    }
}

const authService = new AuthService();

export default authService;


// WEBPACK FOOTER //
// ./src/services/AuthService.js